import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { createResourceLocatorString } from '../../../../util/routes';
import { joinSpace } from '../../CircleCommunityPage.duck';
import css from './SpaceGroups.module.css';
import { FormattedMessage } from '../../../../util/reactIntl';

const SpaceGroups = props => {
  const dispatch = useDispatch();
  const {
    spaceListData = [],
    history,
    routeConfiguration,
    activeIndexId,
    requestNewSpace,
    isRequestSpace,
    onRequestGroupClick,
    onSetActiveTab,
    checkCreatePostAuth,
    userModeratorsGroups
  } = props;
  const [isOpen, setIsOpen] = useState(true);

  const isMyGroups = Array.isArray(spaceListData)
    ? spaceListData.filter(item => {
      const isModerator = Array.isArray(userModeratorsGroups) &&
        userModeratorsGroups.some(st => st.status == "active" && st.groupId == item.id);
      const canManage = item.is_member;
      return isModerator && canManage;
    })
    : [];

  if (isMyGroups.length == 0) return null;

  const handleRequestToJoinSpace = item => {
    console.log('item', item);

    const apiParams = {
      spaceId: item.id,
    };
    const response = dispatch(joinSpace(item.id));
    console.log('response', response);
  };

  const toggleVisibility = () => {
    setIsOpen(!isOpen); // Toggle the state
  };

  const fetchSpaceDetails = space => {
    console.log('space', space)
    const { id, slug } = space;
    onSetActiveTab('')
    return history.push(
      createResourceLocatorString('MyGroupCommunityPage', routeConfiguration, { id, slug }, {})
    );
  };

  return (
    <div>
      <div onClick={toggleVisibility} className={css.accordionHeading}>
        <div className={css.accordionTitle}>
          <FormattedMessage id='SpaceGroups.moderatedGroups' />
        </div>{' '}
        <span className={css.arrows}>{isOpen ? '-' : '+'}</span>
      </div>
      {isOpen && (
        <>
          <div className={css.accordionData}>
            {Array.isArray(isMyGroups)
              ? isMyGroups
                .sort((a, b) => a.name.localeCompare(b.name)).map(item => (
                  <div
                    className={css.spaceItems}
                    key={item.id}
                    onClick={() => fetchSpaceDetails(item)}
                  >
                    <ProfileIconCard type="green" />
                    <span className={item.id == activeIndexId ? css.boldText : ''}>
                      {item.name}
                    </span>
                    {item.pendingCount ? <span className={css.pendingCount}>
                      {item.pendingCount}
                    </span> : null}
                  </div>
                ))
              : null}
          </div>
        </>
      )}
      <div className={css.spacer}></div>
    </div>
  );
};

export default SpaceGroups;
